{
  "organization.title": "Organisatie",
  "onboarding.title": "Klant toevoegen",
  "onboarding.create": "Klant aanmaken en eigenaar uitnodigen",
  "onboarding.created": "Klant aangemaakt",
  "onboarding.invited": "Uitnodiging klaargezet voor {email}.",
  "onboarding.slug": "Organisatiecode",
  "onboarding.slug_hint": "Kleine letters en koppeltekens. De code blijft gelijk.",
  "onboarding.locale": "Basistaal",
  "onboarding.plan": "Pakket",
  "onboarding.owner": "Eigenaar uitnodigen",
  "onboarding.demo": "Demo-organisatie met fictieve gegevens",
  "onboarding.website_separate": "De website krijgt een eigen ontwerp en wordt apart ingericht. De eigenaar kan na acceptatie woningen, contacten en het team beheren.",
  "organization.name": "Kantoornaam",
  "organization.legal_name": "Statutaire naam",
  "organization.timezone": "Tijdzone",
  "organization.registrations": "Registraties",
  "organization.registration_label": "Soort registratie",
  "organization.registration_value": "Nummer of vermelding",
  "organization.registration_add": "Registratie toevoegen",
  "organization.registration_remove": "Registratie {label} verwijderen",
  "organization.publish_required": "Publiceer de website opnieuw om openbare wijzigingen zichtbaar te maken.",
  "organization.areas.title": "Gebieden",
  "organization.areas.name": "Naam",
  "organization.areas.add_name": "Naam toevoegen in taal",
  "organization.areas.remove_name": "Naam in {locale} verwijderen",
  "organization.areas.kind": "Soort gebied",
  "organization.areas.parent": "Bovengebied",
  "organization.areas.no_parent": "Geen bovengebied",
  "organization.areas.new": "Gebied toevoegen",
  "organization.areas.edit": "Gebied bewerken",
  "organization.areas.edit_named": "{name} bewerken",
  "organization.areas.remove_named": "{name} verwijderen",
  "organization.areas.empty": "Geen gebieden vastgelegd",
  "organization.areas.slug": "Gebiedscode",
  "organization.areas.slug_hint": "Kleine letters en koppeltekens. De code blijft na aanmaken gelijk.",
  "organization.areas.aliases": "Andere namen",
  "organization.areas.aliases_hint": "Scheid meerdere namen met een komma.",
  "organization.areas.remove_title": "Gebied verwijderen?",
  "organization.areas.remove_body": "Je verwijdert {slug}. Een gebied dat nog in gebruik is, kun je niet verwijderen.",
  "organization.areas.removed": "Gebied verwijderd",
  "organization.area_kind.island": "Eiland",
  "organization.area_kind.region": "Regio",
  "organization.area_kind.municipality": "Gemeente",
  "organization.area_kind.locality": "Plaats",
  "organization.area_kind.district": "Wijk"
}
